// https://en.wikipedia.org/wiki/Telephone_numbers_in_Denmark - All numbers have 8 digits after area code

import { danishCountryCodeString } from "./danishCountryCode";

export const danishAreaMobile = new RegExp(`^(${danishCountryCodeString})[1-9](\\d{7})$`);
